<template>
    <div class="navBlock">
        <ul class="navlist">
            <img src="@/assets/images/logo-web.png" alt="logo" class="logo-image">
            <li><a href="/" :class="['navItem', { active: currentPage === 'index' }]">首页</a></li>
            <li><a href="/res/" :class="['navItem', { active: currentPage === 'res' }]">库库</a></li>
            <li><a href="/download/" :class="['navItem', { active: currentPage === 'download' }]">下载</a></li>
            <li><a href="/upload/" :class="['navItem', { active: currentPage === 'upload' }]">上传</a></li>
            <li><a href="/contact/" :class="['navItem', { active: currentPage === 'contact' }]">联系</a></li>
        </ul>
    </div>  
</template>

<script>
    export default{
        name:'navigation',
        props: ['currentPage']
    }
</script>

<style>
    .navBlock{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
        background-color: white;
        box-sizing: border-box;
        width: 100%;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
        margin: 0px;
        padding: 0px;
        display: flex;
        align-items: center;
    }

    .navlist{
        display: flex;
        margin: 0 auto;
        padding: 0px;
        width: 1280px;
        list-style: none;
    }

    .navlist{
        user-select: none; 
    }

    .navItem{
        color: gray;
        text-decoration: none;
        display: inline-block;
        padding-top: 25px;
        padding-bottom: 8px;
        margin-left: 24px;
        margin-right: 24px;
        position: relative;
        user-select: none; 
    }

    .active{
        color: #45B5B5;
        border-bottom: 2px solid #45B5B5;
        font-weight: 600;
    }

    .navItem:hover {
        color: #000;
        border-bottom: 2px solid #45B5B5;
    }

    .logo-image{
        width: auto;
        height: auto;
        padding-right: 24px;
        margin-top: 12px;
        margin-bottom: 12px;
    }
</style>